import { render, staticRenderFns } from "./MaterielGeneral.vue?vue&type=template&id=f3e8f816&scoped=true&"
import script from "./MaterielGeneral.vue?vue&type=script&lang=js&"
export * from "./MaterielGeneral.vue?vue&type=script&lang=js&"
import style0 from "./MaterielGeneral.vue?vue&type=style&index=0&id=f3e8f816&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e8f816",
  null
  
)

export default component.exports